import api from '../utils/api';

/**
 * Código de migración del usuario autenticado.
 * Devuelve null si no tiene (404): el usuario es admin o la sede no ha generado códigos.
 */
export const getMyMigrationCode = async () => {
  try {
    const response = await api.get('/migration/my-code');
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return null;
    }
    throw error;
  }
};

// ----------------------------- Administración ------------------------------

export const generateMigrationCodes = async (placeId, activatesAt, expiresAt) => {
  const response = await api.post('/migration/codes/generate', {
    place_id: placeId,
    activates_at: activatesAt || null,
    expires_at: expiresAt || null,
  });
  return response.data;
};

export const getMigrationStats = async (placeId) => {
  const response = await api.get('/migration/codes/stats', {
    params: placeId ? { place_id: placeId } : {},
  });
  return response.data;
};

export const listMigrationCodes = async (placeId) => {
  const response = await api.get('/migration/codes', {
    params: placeId ? { place_id: placeId } : {},
  });
  return response.data;
};

export const regenerateMigrationCode = async (userId) => {
  const response = await api.post(`/migration/codes/${userId}/regenerate`);
  return response.data; // { codigo } — se muestra una sola vez
};

export const setMigrationCode = async (userId, codigo) => {
  const response = await api.post(`/migration/codes/${userId}/set`, { codigo });
  return response.data;
};

export const revokeMigrationCode = async (userId) => {
  const response = await api.post(`/migration/codes/${userId}/revoke`);
  return response.data;
};

/** Descarga el CSV de códigos; devuelve el nombre del archivo guardado. */
export const downloadMigrationCodesCsv = async (placeId, soloNoVistos = false) => {
  const response = await api.get('/migration/codes/export', {
    params: {
      ...(placeId ? { place_id: placeId } : {}),
      solo_no_vistos: soloNoVistos,
    },
    responseType: 'blob',
  });

  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : `codigos_migracion${soloNoVistos ? '_no_vistos' : ''}.csv`;

  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
  return filename;
};
